export default __webpack_public_path__ + "static/media/shipping.7de49dcd.png";